var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP003(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731,
    height: 1101,
    viewBox: "0 0 1731 1101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_4606)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M486.434 121.863C488.932 127.892 492.081 133.633 495.827 138.983C501.198 142.714 506.96 145.851 513.013 148.339C506.96 150.828 501.198 153.965 495.827 157.696C492.081 163.046 488.932 168.787 486.434 174.816C483.936 168.787 480.786 163.046 477.041 157.696C471.67 153.965 465.907 150.828 459.854 148.339C465.907 145.851 471.67 142.714 477.041 138.983C480.786 133.633 483.936 127.892 486.434 121.863Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.14 667.635C1387.4 675.456 1391.5 682.902 1396.37 689.844C1403.34 694.695 1410.81 698.78 1418.66 702.028C1410.81 705.253 1403.34 709.321 1396.37 714.161C1391.5 721.103 1387.4 728.549 1384.14 736.37C1380.9 728.548 1376.82 721.101 1371.96 714.161C1364.99 709.321 1357.51 705.253 1349.66 702.028C1357.51 698.78 1364.99 694.695 1371.96 689.844C1376.82 682.904 1380.9 675.457 1384.14 667.635Z",
    fill: "#39AA8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M391.974 674.178C391.974 674.178 400.229 693.183 405.036 698.018C409.843 702.852 428.906 711.03 428.906 711.03C428.906 711.03 409.843 719.275 405.036 724.076C400.229 728.877 391.974 747.916 391.974 747.916C391.974 747.916 383.719 728.877 378.912 724.076C374.105 719.275 355.043 711.03 355.043 711.03C355.043 711.03 374.105 702.819 378.912 698.018C383.719 693.217 391.974 674.178 391.974 674.178Z",
    fill: "#D364C6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1331.39 920.622C1335.2 920.622 1338.92 919.498 1342.09 917.391C1345.25 915.284 1347.72 912.289 1349.18 908.785C1350.64 905.281 1351.02 901.425 1350.27 897.705C1349.53 893.986 1347.7 890.569 1345.01 887.887C1342.31 885.205 1338.88 883.379 1335.15 882.639C1331.41 881.899 1327.54 882.279 1324.03 883.73C1320.51 885.182 1317.5 887.639 1315.39 890.793C1313.27 893.946 1312.14 897.654 1312.14 901.446C1312.14 906.532 1314.17 911.41 1317.78 915.006C1321.39 918.602 1326.29 920.622 1331.39 920.622Z",
    fill: "url(#paint0_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1008.06 33.3874C1009.43 30.0587 1011.16 26.8872 1013.22 23.928C1016.2 21.8733 1019.4 20.1494 1022.77 18.787C1019.4 17.4313 1016.2 15.7071 1013.22 13.646C1011.16 10.6868 1009.43 7.51527 1008.06 4.18652C1006.68 7.51527 1004.95 10.6868 1002.9 13.646C999.921 15.7175 996.717 17.4425 993.348 18.787C996.714 20.1383 999.917 21.8629 1002.9 23.928C1004.95 26.8872 1006.68 30.0587 1008.06 33.3874Z",
    fill: "url(#paint1_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1415.72 286.479C1414.35 289.826 1412.62 293.015 1410.56 295.99C1407.58 298.042 1404.37 299.766 1401.01 301.131C1404.37 302.497 1407.58 304.221 1410.56 306.272C1412.61 309.255 1414.34 312.442 1415.72 315.783",
    fill: "url(#paint2_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1283.86 497.774C1285.66 493.421 1287.95 489.282 1290.67 485.436C1294.54 482.752 1298.7 480.494 1303.06 478.701C1298.7 476.909 1294.54 474.65 1290.67 471.966C1287.96 468.113 1285.67 463.976 1283.86 459.628C1282.07 463.977 1279.8 468.115 1277.1 471.966C1273.23 474.65 1269.07 476.909 1264.71 478.701C1269.07 480.494 1273.23 482.752 1277.1 485.436C1279.81 489.281 1282.08 493.42 1283.86 497.774Z",
    fill: "url(#paint3_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M469.712 598.538C471.073 595.187 472.804 591.997 474.873 589.027C477.86 586.976 481.061 585.252 484.421 583.886C481.051 582.542 477.848 580.817 474.873 578.745C472.793 575.782 471.062 572.591 469.712 569.234C468.355 572.588 466.624 575.778 464.551 578.745C461.593 580.814 458.406 582.539 455.055 583.886C458.396 585.255 461.58 586.979 464.551 589.027C466.614 592.001 468.344 595.19 469.712 598.538Z",
    fill: "url(#paint4_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M672.053 132.207C672.053 133.224 671.75 134.218 671.183 135.063C670.616 135.909 669.81 136.568 668.867 136.957C667.924 137.346 666.886 137.448 665.885 137.249C664.884 137.051 663.964 136.561 663.242 135.842C662.52 135.123 662.029 134.207 661.83 133.21C661.631 132.213 661.733 131.179 662.123 130.24C662.514 129.3 663.176 128.497 664.024 127.933C664.873 127.368 665.871 127.066 666.892 127.066C668.26 127.066 669.573 127.608 670.541 128.572C671.509 129.536 672.053 130.844 672.053 132.207ZM711.483 42.1367C709.533 42.1367 707.627 42.7126 706.006 43.7916C704.385 44.8705 703.122 46.4041 702.376 48.1983C701.629 49.9926 701.434 51.9669 701.815 53.8717C702.195 55.7764 703.134 57.5261 704.512 58.8994C705.891 60.2726 707.647 61.2078 709.56 61.5867C711.472 61.9655 713.454 61.7711 715.255 61.0279C717.056 60.2847 718.596 59.0261 719.679 57.4114C720.762 55.7966 721.34 53.8981 721.34 51.956C721.34 49.3518 720.302 46.8542 718.453 45.0127C716.604 43.1712 714.097 42.1367 711.483 42.1367ZM731.198 160.02C727.29 160.02 723.471 161.174 720.221 163.335C716.972 165.496 714.438 168.568 712.941 172.163C711.443 175.758 711.049 179.714 711.807 183.533C712.566 187.351 714.443 190.859 717.202 193.615C719.962 196.371 723.479 198.25 727.31 199.015C731.141 199.781 735.114 199.398 738.726 197.916C742.339 196.434 745.43 193.918 747.608 190.687C749.786 187.455 750.954 183.654 750.964 179.761C750.971 177.171 750.465 174.605 749.475 172.211C748.484 169.816 747.029 167.639 745.193 165.805C743.357 163.971 741.176 162.516 738.774 161.524C736.373 160.531 733.798 160.02 731.198 160.02ZM560.214 182.949C558.252 182.939 556.331 183.509 554.694 184.587C553.058 185.666 551.78 187.204 551.022 189.007C550.264 190.809 550.061 192.795 550.437 194.714C550.814 196.632 551.753 198.395 553.137 199.781C554.521 201.167 556.286 202.112 558.21 202.497C560.133 202.882 562.128 202.689 563.942 201.944C565.756 201.198 567.306 199.933 568.398 198.309C569.489 196.685 570.071 194.774 570.071 192.82C570.071 190.211 569.034 187.708 567.187 185.858C565.34 184.008 562.833 182.962 560.214 182.949Z",
    fill: "url(#paint5_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1238.91 167.722C1238.77 166.687 1238.95 165.636 1239.43 164.708C1239.91 163.779 1240.66 163.018 1241.58 162.524C1242.51 162.031 1243.56 161.829 1244.6 161.945C1245.64 162.061 1246.62 162.49 1247.41 163.175C1248.2 163.86 1248.76 164.769 1249.02 165.779C1249.28 166.79 1249.23 167.856 1248.87 168.835C1248.5 169.814 1247.85 170.659 1246.99 171.26C1246.14 171.86 1245.12 172.186 1244.07 172.195C1242.79 172.266 1241.54 171.839 1240.58 171.003C1239.61 170.168 1239.01 168.991 1238.91 167.722ZM1207.27 260.826C1209.21 260.656 1211.06 259.917 1212.58 258.702C1214.1 257.487 1215.22 255.851 1215.81 254C1216.4 252.148 1216.42 250.166 1215.87 248.302C1215.33 246.438 1214.24 244.776 1212.75 243.527C1211.26 242.278 1209.43 241.498 1207.49 241.284C1205.56 241.071 1203.6 241.434 1201.87 242.328C1200.14 243.222 1198.71 244.606 1197.77 246.306C1196.83 248.007 1196.42 249.946 1196.59 251.88C1196.7 253.167 1197.06 254.419 1197.66 255.566C1198.26 256.712 1199.07 257.73 1200.07 258.561C1201.06 259.391 1202.21 260.019 1203.44 260.408C1204.68 260.797 1205.98 260.939 1207.27 260.826ZM1177.54 144.999C1181.43 144.67 1185.13 143.203 1188.17 140.781C1191.22 138.359 1193.48 135.092 1194.66 131.393C1195.84 127.693 1195.9 123.727 1194.82 119.996C1193.74 116.265 1191.58 112.936 1188.6 110.43C1185.62 107.924 1181.97 106.354 1178.09 105.917C1174.22 105.48 1170.3 106.196 1166.84 107.975C1163.38 109.755 1160.52 112.517 1158.63 115.913C1156.74 119.31 1155.91 123.187 1156.23 127.057C1156.44 129.63 1157.16 132.135 1158.35 134.43C1159.54 136.725 1161.17 138.764 1163.15 140.431C1165.13 142.097 1167.42 143.358 1169.89 144.142C1172.36 144.926 1174.96 145.217 1177.54 144.999ZM1345.79 107.675C1348.39 107.453 1350.8 106.213 1352.48 104.228C1354.16 102.243 1354.99 99.6743 1354.77 97.0847C1354.66 95.7985 1354.3 94.5463 1353.71 93.3994C1353.11 92.2525 1352.3 91.2335 1351.31 90.4004C1350.32 89.5674 1349.17 88.9367 1347.94 88.5443C1346.71 88.1519 1345.41 88.0056 1344.11 88.1136C1342.82 88.2216 1341.57 88.5819 1340.41 89.1739C1339.26 89.7658 1338.24 90.5779 1337.4 91.5637C1335.72 93.5546 1334.89 96.1323 1335.11 98.7298C1335.22 100.016 1335.58 101.269 1336.18 102.415C1336.78 103.561 1337.59 104.579 1338.59 105.41C1339.58 106.241 1340.73 106.869 1341.96 107.257C1343.2 107.646 1344.5 107.788 1345.79 107.675Z",
    fill: "url(#paint6_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M893.946 690.254C891.173 694.006 888.007 697.453 884.501 700.536C880.108 702.259 875.539 703.5 870.876 704.237C874.643 706.999 878.103 710.153 881.198 713.646C882.898 718.028 884.127 722.577 884.862 727.218C887.656 723.467 890.839 720.021 894.359 716.936C898.75 715.207 903.319 713.966 907.984 713.234C904.217 710.473 900.757 707.319 897.662 703.826C895.926 699.452 894.68 694.9 893.946 690.254Z",
    fill: "url(#paint7_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M581.551 295.836C579.435 298.773 576.994 301.463 574.274 303.856C570.949 305.187 567.488 306.152 563.952 306.735C566.763 308.876 569.341 311.306 571.642 313.984C572.943 317.304 573.895 320.75 574.481 324.266C576.699 321.396 579.206 318.76 581.964 316.4C585.29 315.082 588.751 314.134 592.286 313.572C589.332 311.434 586.615 308.986 584.183 306.272C582.942 302.895 582.06 299.397 581.551 295.836Z",
    fill: "url(#paint8_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M826.028 147.62C823.89 150.555 821.432 153.245 818.699 155.64C815.374 156.96 811.912 157.908 808.377 158.468C811.323 160.597 814.024 163.045 816.428 165.768C817.764 169.08 818.733 172.528 819.318 176.05C821.434 173.113 823.875 170.423 826.595 168.03C829.921 166.699 833.382 165.734 836.917 165.151C833.98 163.03 831.281 160.6 828.866 157.902C827.541 154.59 826.589 151.141 826.028 147.62Z",
    fill: "url(#paint9_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M643.327 451.352C643.122 452.601 642.547 453.762 641.678 454.685C640.808 455.608 639.682 456.252 638.443 456.535C637.204 456.819 635.909 456.728 634.722 456.275C633.535 455.822 632.511 455.028 631.779 453.993C631.047 452.957 630.641 451.729 630.613 450.463C630.585 449.197 630.936 447.952 631.621 446.886C632.306 445.819 633.295 444.98 634.46 444.476C635.626 443.971 636.916 443.823 638.166 444.052C639.808 444.365 641.264 445.301 642.227 446.663C643.19 448.025 643.584 449.706 643.327 451.352ZM711.452 343.391C708.951 343.024 706.397 343.403 704.112 344.481C701.827 345.558 699.913 347.285 698.612 349.445C697.312 351.604 696.682 354.099 696.803 356.614C696.924 359.13 697.79 361.553 699.292 363.579C700.794 365.605 702.864 367.142 705.242 367.997C707.62 368.852 710.199 368.986 712.653 368.383C715.108 367.78 717.328 366.466 719.034 364.608C720.74 362.749 721.855 360.429 722.239 357.94C722.502 356.275 722.432 354.574 722.031 352.936C721.63 351.298 720.907 349.755 719.904 348.397C718.901 347.04 717.638 345.893 716.187 345.025C714.736 344.157 713.127 343.584 711.452 343.34V343.391ZM713.878 498.547C708.819 497.74 703.634 498.451 698.982 500.591C694.331 502.73 690.424 506.2 687.759 510.558C685.094 514.917 683.792 519.967 684.019 525.065C684.246 530.164 685.991 535.08 689.032 539.187C692.073 543.294 696.272 546.406 701.095 548.127C705.918 549.849 711.146 550.101 716.114 548.852C721.081 547.603 725.563 544.909 728.988 541.114C732.414 537.319 734.627 532.594 735.348 527.542C736.313 520.862 734.603 514.072 730.586 508.637C726.569 503.203 720.568 499.56 713.878 498.495V498.547ZM489.993 494.948C487.49 494.569 484.929 494.938 482.637 496.009C480.344 497.08 478.421 498.805 477.113 500.965C475.804 503.124 475.168 505.622 475.285 508.142C475.402 510.662 476.267 513.091 477.77 515.121C479.274 517.151 481.348 518.691 483.73 519.547C486.112 520.402 488.696 520.535 491.154 519.927C493.612 519.32 495.833 517.999 497.538 516.133C499.242 514.268 500.352 511.94 500.728 509.445C500.985 507.788 500.911 506.096 500.51 504.467C500.109 502.838 499.389 501.303 498.392 499.952C497.395 498.6 496.139 497.458 494.698 496.591C493.257 495.723 491.658 495.147 489.993 494.896V494.948Z",
    fill: "url(#paint10_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M470.34 938.307C474.996 937.554 479.721 937.313 484.429 937.587C488.806 939.451 492.961 941.797 496.816 944.579C496.084 939.938 495.859 935.232 496.145 930.544C498.014 926.241 500.35 922.155 503.112 918.36C498.454 919.091 493.73 919.315 489.023 919.028C484.706 917.141 480.605 914.797 476.791 912.036C477.548 916.691 477.79 921.415 477.514 926.122C475.57 930.43 473.165 934.515 470.34 938.307Z",
    fill: "url(#paint11_radial_329_4606)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.16 821.521C1168.79 715.252 1195.51 516.347 1088.83 377.253C982.144 238.16 782.465 211.549 642.83 317.818C503.195 424.086 476.482 622.991 583.163 762.085C689.845 901.179 889.524 927.789 1029.16 821.521Z",
    fill: "url(#paint12_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1102.6 835.253C1249.84 688.591 1249.84 450.806 1102.6 304.144C955.372 157.482 716.661 157.482 569.429 304.144C422.197 450.805 422.197 688.591 569.429 835.253C716.661 981.914 955.372 981.914 1102.6 835.253Z",
    fill: "url(#paint13_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1134.19 458.858C1120.12 527.67 1082.06 589.303 1026.75 632.843C971.432 676.382 902.437 699.021 831.975 696.749C761.514 694.477 694.132 667.441 641.762 620.43C589.391 573.418 555.41 509.462 545.836 439.888C524.441 487.362 515.109 539.354 518.666 591.271C522.223 643.189 538.558 693.436 566.23 737.575C593.902 781.714 632.058 818.386 677.33 844.354C722.602 870.322 773.597 884.786 825.81 886.47C878.024 888.153 929.851 877.004 976.714 854.007C1023.58 831.01 1064.03 796.872 1094.51 754.608C1124.99 712.345 1144.56 663.255 1151.48 611.675C1158.4 560.095 1152.46 507.611 1134.19 458.858Z",
    fill: "url(#paint14_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1125.31 701.667C1066.51 740.441 995.832 757.232 925.793 749.064C855.755 740.897 790.878 708.298 742.658 657.044C694.438 605.79 665.986 539.189 662.343 469.039C658.7 398.889 680.101 329.718 722.755 273.781C673.906 292.27 630.38 322.458 596.021 361.677C561.662 400.897 537.527 447.941 525.749 498.655C513.97 549.37 514.91 602.193 528.486 652.459C542.062 702.725 567.856 748.888 603.589 786.87C639.322 824.851 683.896 853.483 733.371 870.235C782.847 886.988 835.704 891.346 887.271 882.924C938.839 874.503 987.531 853.561 1029.05 821.949C1070.56 790.336 1103.63 749.026 1125.31 701.667Z",
    fill: "url(#paint15_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M904.112 441.378C899.453 448.585 892.752 454.254 884.858 457.667C876.964 461.08 868.231 462.085 859.764 460.554C851.297 459.023 843.475 455.025 837.289 449.065C831.103 443.106 826.83 435.453 825.011 427.075C823.191 418.696 823.907 409.968 827.068 401.995C830.228 394.022 835.692 387.161 842.767 382.281C849.842 377.401 858.211 374.721 866.816 374.579C875.42 374.437 883.874 376.841 891.107 381.485C900.803 387.711 907.62 397.518 910.058 408.749C912.497 419.981 910.359 431.717 904.112 441.378Z",
    fill: "#F4AF00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M826.18 534.48C826.18 534.994 826.542 535.509 826.697 536.023C827.746 540.404 830.176 544.335 833.631 547.24C837.086 550.145 841.384 551.871 845.895 552.165C850.414 552.243 854.842 550.899 858.549 548.323C862.256 545.748 865.052 542.073 866.539 537.822C867.032 536.148 867.327 534.423 867.417 532.681C867.546 528.664 866.491 524.697 864.381 521.27C862.272 517.844 859.2 515.108 855.547 513.402C851.93 511.655 847.873 511.019 843.893 511.578C839.913 512.136 836.19 513.863 833.199 516.538L831.651 518.132C829.437 520.196 827.798 522.797 826.894 525.68C825.989 528.563 825.85 531.631 826.49 534.583L826.18 534.48Z",
    fill: "#F4AF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M932.446 514.227L930.692 513.815C927.729 512.944 924.564 513.037 921.659 514.082C918.753 515.127 916.258 517.069 914.538 519.625C912.956 522.248 912.235 525.297 912.476 528.347C912.717 531.397 913.906 534.297 915.88 536.641C916.286 537.098 916.666 537.579 917.015 538.081C918.534 539.754 920.418 541.056 922.522 541.887C924.627 542.718 926.895 543.056 929.152 542.874C931.408 542.693 933.592 541.996 935.536 540.839C937.479 539.682 939.129 538.096 940.358 536.202C941.587 534.308 942.362 532.158 942.624 529.918C942.886 527.678 942.627 525.408 941.867 523.284C941.107 521.16 939.867 519.238 938.242 517.667C936.618 516.097 934.652 514.92 932.498 514.227H932.446Z",
    fill: "#F4AF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M997.836 446.159C1027.72 465.386 1057.7 419.117 1027.77 399.89C997.837 380.662 967.903 426.931 997.836 446.159Z",
    fill: "#F4AF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.87 551.447C1021.93 552.749 1024.42 553.186 1026.79 552.66C1029.17 552.135 1031.24 550.69 1032.54 548.645C1033.85 546.6 1034.29 544.121 1033.76 541.754C1033.24 539.387 1031.79 537.326 1029.73 536.024C1027.68 534.722 1025.19 534.286 1022.81 534.811C1020.44 535.336 1018.37 536.781 1017.06 538.826C1015.75 540.871 1015.32 543.35 1015.84 545.717C1016.37 548.084 1017.82 550.145 1019.87 551.447Z",
    fill: "#F4AF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M748.715 495.718C752.384 498.042 756.664 499.229 761.011 499.131C765.358 499.032 769.579 497.651 773.138 495.163C776.698 492.675 779.437 489.191 781.009 485.152C782.58 481.114 782.915 476.701 781.969 472.473C781.024 468.245 778.84 464.391 775.696 461.399C772.552 458.407 768.587 456.411 764.304 455.664C760.021 454.916 755.611 455.45 751.633 457.199C747.654 458.948 744.286 461.833 741.954 465.489C738.875 470.384 737.837 476.284 739.061 481.931C740.285 487.578 743.675 492.525 748.508 495.718H748.715Z",
    fill: "#F4AF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M810.956 402.769C823.549 410.84 836.142 391.407 823.549 383.336C810.956 375.264 798.415 394.697 810.956 402.769Z",
    fill: "#F4AF00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M701.853 394.236H699.427C697.029 394.158 694.652 394.7 692.527 395.809C690.401 396.919 688.601 398.558 687.302 400.567C686.002 402.577 685.247 404.887 685.111 407.273C684.975 409.66 685.462 412.04 686.525 414.183L687.764 416.291C688.965 418.646 690.769 420.643 692.993 422.082C695.217 423.52 697.783 424.348 700.431 424.483C703.079 424.617 705.716 424.054 708.076 422.848C710.436 421.643 712.434 419.838 713.87 417.617C715.305 415.396 716.127 412.837 716.252 410.199C716.377 407.56 715.801 404.936 714.582 402.59C713.363 400.244 711.544 398.26 709.309 396.838C707.074 395.417 704.502 394.608 701.853 394.493V394.236Z",
    fill: "#F4AF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M911.803 394.338C916.525 397.27 922.19 398.299 927.647 397.217C932.41 396.196 936.67 393.561 939.701 389.762C942.733 385.962 944.347 381.233 944.27 376.381C944.193 371.528 942.43 366.852 939.279 363.15C936.129 359.447 931.788 356.948 926.995 356.077C922.202 355.206 917.254 356.018 912.994 358.374C908.735 360.73 905.427 364.484 903.635 368.997C901.843 373.51 901.678 378.502 903.167 383.123C904.656 387.744 907.708 391.708 911.803 394.338Z",
    fill: "#F4AF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M892.964 639.255C905.505 647.326 918.098 627.893 905.505 619.771C892.913 611.648 880.371 631.184 892.964 639.255Z",
    fill: "#F4AF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M948.394 620.543C959.955 627.946 971.515 610.261 959.955 602.652C948.394 595.043 936.833 612.934 948.394 620.543Z",
    fill: "#F4AF00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M947.259 467.546C959.49 475.412 971.774 456.493 959.542 448.627C947.311 440.761 935.027 459.68 947.259 467.546Z",
    fill: "#F4AF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M918.201 393.772C928.524 400.558 939.258 384.261 928.524 377.475C917.789 370.689 907.467 387.037 918.201 393.772Z",
    fill: "#F4AF00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M593.318 586.303C597.077 588.711 601.468 589.955 605.936 589.879C610.405 589.802 614.75 588.407 618.423 585.872C622.096 583.336 624.932 579.772 626.573 575.631C628.214 571.49 628.586 566.958 627.641 562.607C626.697 558.255 624.479 554.28 621.268 551.184C618.056 548.088 613.996 546.01 609.599 545.212C605.203 544.413 600.667 544.931 596.566 546.7C592.464 548.469 588.982 551.408 586.557 555.148C583.368 560.19 582.29 566.276 583.554 572.1C584.818 577.924 588.323 583.023 593.318 586.303Z",
    fill: "#F4AF00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M667.067 730.302C667.743 730.582 668.496 730.618 669.196 730.405C669.896 730.192 670.5 729.742 670.903 729.134C671.306 728.525 671.484 727.795 671.406 727.07C671.327 726.345 670.998 725.67 670.474 725.161C669.798 724.881 669.045 724.845 668.345 725.058C667.645 725.271 667.041 725.721 666.638 726.329C666.235 726.938 666.057 727.668 666.135 728.393C666.214 729.118 666.543 729.793 667.067 730.302Z",
    fill: "#F4AF00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M729.258 727.064C741.851 735.135 754.444 715.702 741.851 707.631C729.258 699.559 716.665 718.992 729.258 727.064Z",
    fill: "#F4AF00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M734.523 811.839C757.644 826.645 780.972 790.915 757.644 775.852C734.317 760.789 711.195 796.776 734.523 811.839Z",
    fill: "#F4AF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M638.734 717.245C638.763 716.714 638.763 716.182 638.734 715.651C638.814 713.555 638.343 711.473 637.37 709.613C636.396 707.752 634.953 706.176 633.182 705.04C631.411 703.904 629.374 703.246 627.271 703.133C625.167 703.019 623.071 703.454 621.187 704.393L619.794 705.266C617.793 706.38 616.111 707.984 614.91 709.928C613.708 711.872 613.026 714.09 612.929 716.371C612.843 718.604 613.343 720.82 614.38 722.802C615.416 724.784 616.953 726.462 618.839 727.671C620.725 728.881 622.896 729.579 625.135 729.698C627.375 729.817 629.608 729.352 631.612 728.35C633.655 727.261 635.383 725.669 636.63 723.724C637.877 721.78 638.602 719.549 638.734 717.245Z",
    fill: "#F4AF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M949.788 736.934C952.37 738.537 955.368 739.346 958.409 739.261C961.45 739.176 964.398 738.201 966.886 736.457C969.374 734.713 971.291 732.277 972.397 729.455C973.504 726.632 973.751 723.547 973.109 720.585C972.466 717.624 970.962 714.916 968.783 712.801C966.605 710.685 963.85 709.256 960.861 708.691C957.872 708.126 954.783 708.451 951.978 709.625C949.174 710.798 946.778 712.769 945.091 715.291C942.892 718.798 942.153 723.02 943.03 727.062C943.907 731.103 946.331 734.645 949.788 736.934Z",
    fill: "#F4AF00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M998.405 760.07C998.766 760.327 999.127 759.761 998.766 759.555C998.404 759.35 998.043 759.864 998.405 760.07Z",
    fill: "#F4AF00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.36 603.267C1067.92 610.67 1079.54 592.985 1067.98 585.377C1056.41 577.768 1044.8 595.659 1056.36 603.267Z",
    fill: "#F4AF00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.61 774.259C1039.95 785.363 1057.29 758.836 1039.95 747.474C1022.61 736.112 1005.27 762.897 1022.61 774.259Z",
    fill: "#F4AF00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M955.568 606.867C943.634 625.247 936.471 646.294 934.724 668.114C932.976 689.935 936.699 711.846 945.557 731.879C954.415 751.911 968.13 769.438 985.471 782.883C1002.81 796.329 1023.24 805.272 1044.91 808.909C1078.04 780.198 1104.85 744.961 1123.63 705.418C1142.42 665.876 1152.78 622.886 1154.06 579.157C1149.29 574.938 1144.22 571.072 1138.89 567.59C1124.26 558.178 1107.92 551.728 1090.79 548.608C1073.66 545.488 1056.08 545.76 1039.06 549.407C1022.04 553.054 1005.9 560.006 991.577 569.865C977.252 579.724 965.016 592.297 955.568 606.867Z",
    fill: "#F4AF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.58 450.066C1117.36 417.789 1098.87 387.911 1075.87 361.641C1071.42 365.188 1067.57 369.423 1064.46 374.185C1058.27 383.708 1055.34 394.979 1056.13 406.301C1056.92 417.623 1061.37 428.384 1068.83 436.965C1076.29 445.547 1086.34 451.484 1097.47 453.883C1108.61 456.283 1120.23 455.016 1130.58 450.272V450.066Z",
    fill: "#F4AF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M663.61 836.103C676.386 844.295 689.736 851.563 703.557 857.85C717.921 847.804 729.957 834.809 738.854 819.74C747.752 804.67 753.304 787.877 755.137 770.49C756.971 753.103 755.042 735.526 749.482 718.944C743.921 702.362 734.858 687.16 722.902 674.361C710.947 661.562 696.377 651.463 680.174 644.746C663.97 638.029 646.51 634.848 628.969 635.419C611.427 635.989 594.212 640.298 578.483 648.054C562.755 655.81 548.877 666.834 537.785 680.382C561.678 744.5 605.836 799.151 663.61 836.103Z",
    fill: "#F4AF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M545.269 440.761C532.869 468.42 524.542 497.717 520.548 527.747C530.32 526.829 539.585 522.99 547.128 516.733C554.67 510.476 560.137 502.094 562.811 492.686C565.484 483.278 565.24 473.285 562.109 464.018C558.979 454.752 553.109 446.644 545.269 440.761Z",
    fill: "#F4AF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M876.502 847.363C868.482 842.223 859.356 839.044 849.868 838.086C840.38 837.129 830.799 838.419 821.907 841.853C813.015 845.287 805.065 850.766 798.704 857.844C792.343 864.921 787.752 873.397 785.307 882.579C823.84 888.763 863.187 887.822 901.378 879.803C897.159 866.419 888.354 854.938 876.502 847.363Z",
    fill: "#F4AF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M850.799 793.846C858.906 799.049 868.38 801.742 878.023 801.583C887.665 801.425 897.044 798.422 904.974 792.954C912.904 787.487 919.029 779.8 922.574 770.866C926.119 761.932 926.926 752.152 924.892 742.761C922.858 733.37 918.074 724.791 911.146 718.108C904.219 711.425 895.457 706.938 885.97 705.214C876.482 703.49 866.694 704.606 857.844 708.422C848.993 712.238 841.477 718.582 836.245 726.653C832.762 732.014 830.375 738.007 829.221 744.288C828.068 750.57 828.17 757.016 829.522 763.258C830.874 769.5 833.449 775.416 837.101 780.664C840.752 785.913 845.407 790.393 850.799 793.846Z",
    fill: "#F4AF00"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.96 623.421C1374.12 580.236 1323.55 541.165 1214.13 504.098C1189.57 495.77 1162.52 487.852 1134.09 480.347C1137.08 488.464 1139.45 496.8 1141.16 505.28C1144.35 516.031 1146.78 526.991 1148.43 538.08C1161.39 541.73 1174.24 545.535 1185.95 549.39C1296.92 585.377 1314.98 612.213 1317.15 617.097C1313.64 621.313 1289.85 643.059 1173.46 651.491C1079.84 658.225 958.974 653.547 833.097 638.278C707.22 623.01 588.568 598.641 499.386 569.697C388.476 533.71 370.619 506.926 368.193 501.99C371.703 497.775 395.547 476.028 511.876 467.597C524.572 466.723 537.939 466.055 551.615 465.54C556.38 446.856 564.285 429.108 574.995 413.051C546.816 413.565 520.082 414.799 495.36 416.907C380.012 426.726 321.383 452.482 316.067 495.667C313.022 521.012 329.073 544.558 364.426 567.281C389.887 583.629 425.463 599.532 471.155 614.99C564.931 646.71 691.169 673.289 826.594 689.688C962.018 706.088 1090.99 710.561 1189.67 702.13C1305.02 692.362 1363.7 666.605 1368.96 623.421Z",
    fill: "url(#paint16_radial_329_4606)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.96 623.421C1374.12 580.236 1323.55 541.165 1214.13 504.098C1189.57 495.77 1162.52 487.852 1134.09 480.347C1137.08 488.464 1139.45 496.8 1141.16 505.28C1144.35 516.031 1146.78 526.991 1148.43 538.08C1161.39 541.73 1174.24 545.535 1185.95 549.39C1296.92 585.377 1314.98 612.213 1317.15 617.097C1313.64 621.313 1289.85 643.059 1173.46 651.491C1079.84 658.225 958.974 653.547 833.097 638.278C707.22 623.01 588.568 598.641 499.386 569.697C388.476 533.71 370.619 506.926 368.193 501.99C371.703 497.775 395.547 476.028 511.876 467.597C524.572 466.723 537.939 466.055 551.615 465.54C556.38 446.856 564.285 429.108 574.995 413.051C546.816 413.565 520.082 414.799 495.36 416.907C380.012 426.726 321.383 452.482 316.067 495.667C313.022 521.012 329.073 544.558 364.426 567.281C389.887 583.629 425.463 599.532 471.155 614.99C564.931 646.71 691.169 673.289 826.594 689.688C962.018 706.088 1090.99 710.561 1189.67 702.13C1305.02 692.362 1363.7 666.605 1368.96 623.421Z",
    fill: "url(#paint17_radial_329_4606)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.23 538.079C1161.18 541.729 1174.03 545.534 1185.75 549.389C1255.37 571.958 1288.35 590.929 1303.83 603.164C1309.16 600.989 1313.99 597.753 1318.03 593.654C1315.6 588.77 1297.74 561.934 1186.83 525.946C1174.86 522.091 1162.27 518.286 1149.31 514.585C1147.65 503.78 1145.27 493.097 1142.19 482.608L1133.88 480.346C1136.88 488.463 1139.24 496.799 1140.95 505.28C1144.14 516.03 1146.57 526.99 1148.23 538.079Z",
    fill: "url(#paint18_radial_329_4606)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.96 623.42C1369.57 618.28 1369.37 613.079 1368.4 607.997C1357.15 646.452 1298.83 669.689 1190.75 678.84C1092.02 687.271 963.102 682.85 827.678 666.399C692.253 649.947 565.963 623.317 472.188 591.597C426.427 576.071 390.85 560.168 365.458 543.888C337.331 525.844 321.589 507.182 317.719 487.697C316.985 490.313 316.433 492.975 316.067 495.666C313.022 521.011 329.073 544.557 364.426 567.28C389.887 583.628 425.463 599.531 471.155 614.989C564.931 646.709 691.169 673.288 826.594 689.687C962.019 706.087 1090.99 710.56 1189.67 702.129C1305.02 692.361 1363.7 666.604 1368.96 623.42Z",
    fill: "url(#paint19_radial_329_4606)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M552.544 442.097C538.868 442.612 525.552 443.28 512.804 444.154C396.475 452.585 372.683 474.332 369.122 478.547C372.487 484.054 376.969 488.799 382.283 492.479C399.52 484.254 436.009 473.098 511.772 467.597C524.468 466.723 537.835 466.055 551.512 465.54C556.309 446.849 564.249 429.101 574.995 413.051C570.866 413.051 566.84 413.051 562.815 413.359C558.612 422.644 555.177 432.256 552.544 442.097Z",
    fill: "url(#paint20_radial_329_4606)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.44 975.528C1203.81 948.692 1195.66 885.406 1144.51 781.918C1133.05 758.732 1119.64 734.209 1104.77 708.761C1101.14 716.621 1096.9 724.185 1092.08 731.382C1086.67 741.213 1080.62 750.676 1073.96 759.709C1080.52 771.43 1086.76 782.997 1092.44 794.154C1145.34 897.693 1138.89 929.259 1137.13 934.452C1131.66 934.914 1099.41 933.526 1011.15 857.336C940.137 796.158 857.973 707.682 779.836 608.255C701.698 508.828 635.328 408.115 592.594 324.779C539.746 221.188 546.145 189.622 547.9 184.481C553.371 183.967 585.679 185.355 673.932 261.596C683.531 269.874 693.441 278.819 703.453 288.124C720.119 278.289 738.337 271.336 757.334 267.56C737.051 248.076 717.284 230.134 698.292 214.196C609.781 139.857 550.016 116.774 515.644 143.559C495.619 158.982 489.839 187.206 498.922 228.283C505.322 257.724 519.188 294.019 540.52 337.169C584.337 425.697 654.733 533.402 738.857 640.489C822.982 747.576 910.977 841.502 986.586 905.045C1075.3 979.23 1135.07 1002.31 1169.44 975.528Z",
    fill: "url(#paint21_radial_329_4606)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M753.152 321.386C685.13 262.778 660.254 261.75 656.074 262.11C654.853 267.007 654.694 272.107 655.609 277.07C668.718 281.029 695.143 293.881 742.521 334.701C749.953 341.076 757.539 347.965 765.281 355.265C778.063 347.736 792.018 342.384 806.569 339.431C803.782 336.706 800.995 334.29 798.208 331.462C790.424 334.238 782.896 337.679 775.706 341.744C768.222 334.65 760.584 327.761 753.152 321.386Z",
    fill: "url(#paint22_radial_329_4606)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.96 759.71C1080.52 771.432 1086.76 782.999 1092.44 794.155C1125.47 858.829 1135.38 895.381 1137.7 915.02C1141.96 916.514 1146.45 917.228 1150.96 917.128C1152.72 911.987 1159.17 880.421 1106.27 776.83C1100.54 765.674 1094.3 754.158 1087.79 742.385C1094.48 733.379 1100.51 723.913 1105.86 714.058C1106.22 713.544 1106.53 712.978 1106.89 712.413L1104.77 708.763C1101.14 716.623 1096.9 724.186 1092.08 731.383C1086.67 741.214 1080.62 750.677 1073.96 759.71Z",
    fill: "url(#paint23_radial_329_4606)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.27 958.255C1148.85 985.039 1089.08 961.956 1000.57 887.669C924.808 824.075 836.761 730.148 752.843 623.113C668.925 516.077 598.323 408.424 554.557 319.793C533.191 276.557 519.308 240.365 512.908 210.907C506.715 182.22 507.747 159.959 515.437 143.816C495.722 159.496 490.251 187.361 499.128 228.18C505.528 257.621 519.394 293.917 540.726 337.067C584.543 425.595 654.939 533.299 739.063 640.386C823.188 747.474 911.183 841.4 986.791 904.943C1075.35 979.23 1135.12 1002.31 1169.49 975.529C1175.45 970.828 1180.25 964.831 1183.53 957.998L1183.27 958.255Z",
    fill: "url(#paint24_radial_329_4606)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.49 67.2656C1027.36 70.0418 981.373 110.553 981.373 110.553C981.373 110.553 998.301 167.412 1069.37 207.769C1140.44 248.126 1197 225.454 1197 225.454L1208.61 155.331L1031.49 67.2656Z",
    fill: "url(#paint25_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1062.66 83.4102C1060.03 85.1581 1031.69 110.4 1031.69 110.4C1031.69 110.4 1042.02 145.822 1086.5 171.013C1130.99 196.204 1166.03 182.015 1166.03 182.015L1173.26 138.316L1062.66 83.4102Z",
    fill: "url(#paint26_radial_329_4606)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.15 107.521C1176.51 107.048 1176.84 106.55 1177.13 106.03C1183.79 93.2291 1169.75 72.8707 1145.8 60.5323C1121.86 48.1939 1097.08 48.5023 1090.48 61.3034C1090.21 61.815 1089.98 62.3481 1089.81 62.8971C1055.43 49.5305 1029.22 45.0578 1024.93 53.3863C1018.89 65.005 1057.96 97.0848 1112.26 125.36C1166.55 153.636 1215.48 166.488 1221.41 155.075C1225.75 146.49 1207.01 127.725 1176.15 107.521Z",
    fill: "url(#paint27_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1219.09 144.33C1200.46 144.33 1162.32 131.683 1121.29 110.451C1079.07 88.6529 1045.99 64.1817 1036.29 49.1699C1030.35 49.1699 1026.38 50.558 1024.93 53.3855C1018.89 65.0042 1057.96 97.0841 1112.26 125.36C1166.55 153.635 1215.48 166.488 1221.41 155.075C1222.75 152.247 1221.93 148.648 1219.09 144.33Z",
    fill: "url(#paint28_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1219.86 145.719C1219.98 146.88 1219.78 148.051 1219.3 149.112C1213.26 160.731 1164.33 147.415 1110.09 119.397C1066.69 97.0335 1033.04 71.9967 1024.37 56.9336C1025.71 70.6087 1062.61 99.6554 1112.1 125.258C1166.34 153.276 1215.32 166.386 1221.26 154.973C1221.82 153.436 1221.98 151.786 1221.74 150.17C1221.5 148.554 1220.85 147.024 1219.86 145.719Z",
    fill: "url(#paint29_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1089.55 64.3881C1089.55 64.3881 1094.71 80.4794 1132.95 99.2441C1155.92 110.503 1171.5 112.405 1180.43 110.349C1179.04 109.372 1177.65 108.447 1176.15 107.521C1176.51 107.048 1176.84 106.55 1177.13 106.03C1181.77 97.1363 1176.36 84.5408 1164.54 73.5391C1160.87 78.6801 1153.65 81.6105 1139.45 75.1842C1118.81 65.8276 1110.4 57.8076 1107.71 51.7412C1104.27 51.7751 1100.89 52.6679 1097.87 54.3382C1094.86 56.0084 1092.32 58.403 1090.48 61.3035C1090.21 61.815 1089.98 62.3481 1089.81 62.8972H1089.13C1089.24 63.4034 1089.37 63.9016 1089.55 64.3881Z",
    fill: "url(#paint30_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1042.94 65.9293C1042.94 65.9293 1042.94 65.9294 1042.94 65.5181C1042.97 65.2101 1042.97 64.9006 1042.94 64.5927V64.0786C1042.99 63.7721 1042.99 63.4597 1042.94 63.1532C1042.97 63.017 1042.97 62.8781 1042.94 62.7419C1042.79 62.3218 1042.62 61.9099 1042.43 61.5081C1041.85 60.4425 1040.97 59.5675 1039.9 58.989C1038.45 58.2271 1036.75 58.0698 1035.19 58.5517C1033.62 59.0337 1032.31 60.1154 1031.54 61.5595C1031.21 62.2403 1031 62.9699 1030.92 63.7187C1030.89 63.9578 1030.89 64.1993 1030.92 64.4384V64.7469C1030.92 64.7469 1030.92 65.2096 1030.92 65.4153C1030.92 65.6209 1030.92 65.4152 1030.92 65.7751V66.392C1030.92 66.7005 1031.18 66.9576 1031.28 67.266L1031.54 67.6259L1031.9 68.1914L1032.16 68.4998L1032.67 69.014C1032.69 69.0987 1032.69 69.1863 1032.67 69.271C1032.98 69.4895 1033.31 69.6788 1033.65 69.8365C1034.73 70.3923 1035.96 70.6074 1037.16 70.4534C1037.56 70.5024 1037.96 70.5024 1038.35 70.4534C1039.1 70.1997 1039.8 69.8169 1040.42 69.3224C1041.05 68.7958 1041.58 68.1495 1041.96 67.4202C1042.33 66.9525 1042.66 66.4536 1042.94 65.9293Z",
    fill: "url(#paint31_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1068.34 86.4938C1068.38 86.1699 1068.38 85.8408 1068.34 85.517C1068.36 85.3638 1068.36 85.2074 1068.34 85.0543C1068.36 84.7463 1068.36 84.4368 1068.34 84.1289C1068.34 84.1289 1068.34 83.8204 1068.34 83.7176C1068.24 83.2715 1068.08 82.8397 1067.87 82.4324C1067.27 81.3632 1066.38 80.4886 1065.29 79.9133C1064.57 79.5391 1063.79 79.31 1062.98 79.2393C1062.17 79.1686 1061.36 79.2577 1060.59 79.5014C1059.82 79.7451 1059.1 80.1387 1058.48 80.6593C1057.86 81.18 1057.35 81.8175 1056.98 82.5352C1056.64 83.1931 1056.41 83.9066 1056.31 84.643V85.6712C1056.28 85.8931 1056.28 86.1176 1056.31 86.3395C1056.31 86.3395 1056.31 86.3395 1056.31 86.6994C1056.29 86.9216 1056.29 87.1455 1056.31 87.3677C1056.41 87.651 1056.53 87.926 1056.67 88.1903C1056.66 88.3101 1056.66 88.4304 1056.67 88.5502L1057.03 89.1157L1057.29 89.4241L1057.86 89.9382C1057.92 90.0478 1058.01 90.1374 1058.12 90.1953C1058.4 90.4414 1058.71 90.6489 1059.05 90.8122C1060.5 91.5553 1062.18 91.7029 1063.74 91.2235C1065.28 90.7164 1066.57 89.6521 1067.36 88.2417C1067.59 87.8245 1067.77 87.3739 1067.87 86.9051C1068.06 86.8077 1068.22 86.6665 1068.34 86.4938Z",
    fill: "url(#paint32_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1095.33 104.591C1095.35 104.266 1095.35 103.939 1095.33 103.614V103.152V102.226C1095.33 102.226 1095.33 102.226 1095.33 101.815C1095.19 101.391 1095.01 100.979 1094.81 100.581C1094.24 99.4905 1093.34 98.6084 1092.23 98.062C1091.52 97.6859 1090.73 97.454 1089.93 97.3796C1089.12 97.3053 1088.31 97.39 1087.54 97.6288C1086.77 97.8676 1086.05 98.2558 1085.43 98.7713C1084.81 99.2867 1084.3 99.9192 1083.92 100.632C1083.57 101.282 1083.35 102.001 1083.3 102.74C1083.28 102.997 1083.28 103.255 1083.3 103.511C1083.3 103.769 1083.3 103.974 1083.3 104.231V104.54V105.208C1083.4 105.491 1083.52 105.766 1083.66 106.031C1083.66 106.031 1083.66 106.288 1083.66 106.442L1084.08 106.956V107.264L1084.59 107.83H1084.85C1085.14 108.07 1085.45 108.277 1085.78 108.447C1086.51 108.834 1087.32 109.062 1088.15 109.115C1088.93 109.299 1089.75 109.299 1090.53 109.115C1091.27 108.88 1091.97 108.514 1092.59 108.036C1093.22 107.498 1093.74 106.854 1094.14 106.133C1094.34 105.705 1094.5 105.257 1094.6 104.797C1094.6 104.797 1095.28 104.591 1095.33 104.591Z",
    fill: "url(#paint33_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1123.3 120.373C1123.32 120.048 1123.32 119.722 1123.3 119.397V118.934V118.009C1123.33 117.873 1123.33 117.733 1123.3 117.597C1123.2 117.151 1123.04 116.719 1122.84 116.312C1122.24 115.243 1121.34 114.368 1120.26 113.793C1118.8 113.051 1117.12 112.91 1115.56 113.401C1114 113.892 1112.7 114.975 1111.95 116.415C1111.59 117.065 1111.38 117.784 1111.33 118.523C1111.3 118.779 1111.3 119.037 1111.33 119.294C1111.33 119.551 1111.33 119.756 1111.33 120.014C1111.33 120.271 1111.33 120.014 1111.33 120.322V120.99C1111.43 121.274 1111.55 121.549 1111.69 121.813C1111.68 121.933 1111.68 122.053 1111.69 122.173L1112.05 122.738L1112.36 123.047C1112.5 123.243 1112.68 123.416 1112.87 123.561C1113.17 123.784 1113.48 123.99 1113.8 124.178C1114.68 124.633 1115.65 124.87 1116.64 124.87C1117.63 124.87 1118.6 124.633 1119.48 124.178C1120.55 123.599 1121.43 122.724 1122.01 121.659C1122.21 121.23 1122.37 120.782 1122.47 120.322C1122.47 120.322 1123.25 120.476 1123.3 120.373Z",
    fill: "url(#paint34_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1152.41 134.152C1152.44 133.827 1152.44 133.5 1152.41 133.175V132.712C1152.43 132.404 1152.43 132.095 1152.41 131.787C1152.41 131.787 1152.41 131.787 1152.41 131.375C1152.26 130.955 1152.09 130.543 1151.89 130.142C1151.36 129.165 1150.58 128.349 1149.62 127.781C1148.66 127.212 1147.56 126.912 1146.45 126.912C1145.33 126.912 1144.24 127.212 1143.28 127.781C1142.32 128.349 1141.54 129.165 1141 130.142C1140.65 130.792 1140.44 131.511 1140.38 132.249C1140.36 132.506 1140.36 132.764 1140.38 133.021V133.329C1140.36 133.551 1140.36 133.775 1140.38 133.997C1140.36 134.116 1140.36 134.238 1140.38 134.357V134.974C1140.48 135.274 1140.6 135.566 1140.75 135.848V136.208L1141.11 136.773L1141.36 137.082L1141.88 137.596H1142.14C1142.43 137.849 1142.76 138.057 1143.12 138.213C1144.01 138.694 1145 138.947 1146.01 138.947C1147.02 138.947 1148.01 138.694 1148.9 138.213C1149.97 137.616 1150.85 136.723 1151.43 135.642C1151.64 135.217 1151.79 134.768 1151.89 134.306C1151.89 134.306 1152.36 134.306 1152.41 134.152Z",
    fill: "url(#paint35_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1182.65 145.719C1182.7 145.395 1182.7 145.066 1182.65 144.742V144.28C1182.68 143.972 1182.68 143.662 1182.65 143.354C1182.65 143.354 1182.65 143.354 1182.65 142.943C1182.55 142.513 1182.39 142.099 1182.19 141.709C1181.62 140.618 1180.71 139.736 1179.61 139.19C1178.89 138.814 1178.11 138.582 1177.3 138.508C1176.5 138.433 1175.69 138.518 1174.92 138.757C1174.14 138.996 1173.43 139.384 1172.81 139.899C1172.19 140.415 1171.67 141.047 1171.3 141.76C1170.95 142.418 1170.72 143.132 1170.63 143.868V144.896C1170.6 145.136 1170.6 145.377 1170.63 145.616C1170.63 145.616 1170.63 145.616 1170.63 145.976C1170.6 146.181 1170.6 146.388 1170.63 146.593C1170.69 146.888 1170.82 147.167 1170.99 147.416V147.827L1171.35 148.341L1171.61 148.701L1172.12 149.215H1172.43C1172.7 149.478 1173.02 149.687 1173.36 149.832C1173.69 150.012 1174.03 150.151 1174.39 150.243H1174.81C1175.5 150.398 1176.23 150.398 1176.92 150.243C1177.7 150.155 1178.45 149.928 1179.14 149.575C1180.23 148.992 1181.11 148.096 1181.67 147.004C1181.92 146.591 1182.09 146.139 1182.19 145.668C1182.34 145.717 1182.5 145.734 1182.65 145.719Z",
    fill: "url(#paint36_radial_329_4606)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.29 65.7759C1040.73 66.8626 1039.85 67.7574 1038.77 68.3466C1037.7 68.9358 1036.47 69.1928 1035.25 69.0849C1034.02 68.977 1032.86 68.5091 1031.9 67.7407C1030.95 66.9722 1030.24 65.938 1029.88 64.7694C1029.51 63.6009 1029.51 62.3508 1029.86 61.1781C1030.21 60.0054 1030.9 58.9632 1031.85 58.1838C1032.79 57.4044 1033.95 56.9232 1035.17 56.8012C1036.4 56.6793 1037.63 56.9221 1038.71 57.4989C1039.43 57.8726 1040.06 58.3833 1040.58 59.0019C1041.1 59.6205 1041.49 60.3348 1041.73 61.1038C1041.97 61.8727 1042.05 62.6813 1041.98 63.483C1041.9 64.2848 1041.67 65.064 1041.29 65.7759Z",
    fill: "url(#paint37_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1041.29 60.0176C1041.24 60.7564 1041.03 61.4754 1040.67 62.1254C1040.3 62.8387 1039.79 63.4711 1039.16 63.9866C1038.54 64.502 1037.83 64.8903 1037.05 65.1291C1036.28 65.3679 1035.47 65.4526 1034.67 65.3782C1033.86 65.3039 1033.08 65.072 1032.36 64.6959C1031.26 64.1495 1030.35 63.2674 1029.78 62.1768C1029.59 63.6096 1029.91 65.0653 1030.69 66.2858C1031.46 67.5063 1032.65 68.4126 1034.04 68.8439C1035.42 69.2752 1036.92 69.2037 1038.25 68.642C1039.59 68.0803 1040.69 67.0647 1041.34 65.7755C1041.81 64.8839 1042.04 63.8935 1042.03 62.8902C1042.03 61.8868 1041.77 60.9008 1041.29 60.0176Z",
    fill: "url(#paint38_radial_329_4606)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.53 86.7002C1065.96 87.7692 1065.09 88.647 1064.02 89.2225C1062.96 89.7981 1061.74 90.0457 1060.53 89.9341C1059.32 89.8225 1058.18 89.3566 1057.23 88.5953C1056.29 87.8341 1055.59 86.8116 1055.23 85.6569C1054.87 84.5022 1054.87 83.2672 1055.21 82.1077C1055.55 80.9483 1056.24 79.9164 1057.17 79.1424C1058.1 78.3684 1059.24 77.887 1060.45 77.759C1061.66 77.631 1062.87 77.8621 1063.95 78.4231C1064.67 78.7968 1065.3 79.3075 1065.82 79.9261C1066.34 80.5447 1066.73 81.259 1066.96 82.028C1067.2 82.7969 1067.29 83.6055 1067.21 84.4072C1067.14 85.209 1066.91 85.9882 1066.53 86.7002Z",
    fill: "url(#paint39_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1066.53 80.9424C1066.43 81.6788 1066.21 82.3923 1065.86 83.0502C1065.49 83.7679 1064.98 84.4054 1064.36 84.926C1063.74 85.4467 1063.02 85.8402 1062.25 86.0839C1061.48 86.3277 1060.67 86.4167 1059.86 86.346C1059.05 86.2754 1058.27 86.0463 1057.55 85.6721C1056.46 85.0967 1055.57 84.2222 1054.97 83.153C1054.87 84.101 1055 85.0581 1055.34 85.948C1055.68 86.838 1056.23 87.6361 1056.94 88.2789C1057.64 88.9218 1058.49 89.3914 1059.41 89.6506C1060.33 89.9097 1061.3 89.9511 1062.24 89.7715C1063.18 89.5919 1064.06 89.1962 1064.82 88.616C1065.58 88.0358 1066.19 87.2871 1066.61 86.4296C1067.02 85.5721 1067.23 84.6295 1067.22 83.6768C1067.21 82.7241 1066.97 81.7878 1066.53 80.9424Z",
    fill: "url(#paint40_radial_329_4606)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.52 104.591C1092.96 105.672 1092.08 106.562 1091.01 107.147C1089.93 107.733 1088.71 107.988 1087.49 107.881C1086.27 107.774 1085.11 107.308 1084.15 106.544C1083.2 105.78 1082.49 104.752 1082.12 103.588C1081.76 102.425 1081.74 101.179 1082.09 100.008C1082.43 98.8369 1083.11 97.7935 1084.05 97.0095C1084.99 96.2255 1086.14 95.7361 1087.36 95.6032C1088.57 95.4702 1089.8 95.6996 1090.89 96.2625C1091.61 96.6367 1092.25 97.1491 1092.78 97.7704C1093.3 98.3916 1093.69 99.1096 1093.94 99.8831C1094.18 100.657 1094.27 101.471 1094.2 102.278C1094.13 103.086 1093.9 103.872 1093.52 104.591Z",
    fill: "url(#paint41_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1093.47 98.833C1093.36 99.5768 1093.15 100.303 1092.85 100.992C1092.08 102.436 1090.77 103.518 1089.2 104C1087.64 104.482 1085.94 104.325 1084.49 103.563C1083.42 102.984 1082.54 102.109 1081.96 101.044C1081.8 102.274 1082.03 103.523 1082.6 104.624C1083.17 105.726 1084.06 106.629 1085.16 107.213C1086.61 107.975 1088.31 108.132 1089.88 107.65C1091.44 107.168 1092.75 106.086 1093.52 104.642C1093.98 103.742 1094.22 102.743 1094.21 101.731C1094.2 100.72 1093.95 99.7254 1093.47 98.833Z",
    fill: "url(#paint42_radial_329_4606)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.49 120.579C1120.73 122.023 1119.42 123.107 1117.85 123.597C1116.29 124.088 1114.59 123.946 1113.13 123.201C1112.05 122.637 1111.15 121.764 1110.57 120.694C1109.98 119.624 1109.72 118.405 1109.83 117.19C1109.94 115.975 1110.41 114.819 1111.17 113.868C1111.94 112.917 1112.97 112.214 1114.14 111.848C1115.31 111.482 1116.56 111.469 1117.73 111.81C1118.91 112.152 1119.96 112.833 1120.74 113.767C1121.53 114.702 1122.02 115.848 1122.16 117.06C1122.29 118.273 1122.06 119.497 1121.49 120.579Z",
    fill: "url(#paint43_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1121.44 114.872C1121.35 115.608 1121.12 116.322 1120.77 116.98C1120.4 117.698 1119.89 118.335 1119.27 118.856C1118.65 119.376 1117.94 119.77 1117.17 120.014C1116.39 120.257 1115.58 120.346 1114.77 120.276C1113.97 120.205 1113.18 119.976 1112.46 119.602C1111.38 119.038 1110.5 118.159 1109.93 117.083C1109.78 118.313 1110 119.562 1110.57 120.663C1111.14 121.765 1112.04 122.668 1113.13 123.252C1114.31 123.855 1115.64 124.07 1116.95 123.864C1118.25 123.658 1119.45 123.042 1120.38 122.106C1121.31 121.17 1121.91 119.964 1122.1 118.662C1122.29 117.361 1122.06 116.033 1121.44 114.872Z",
    fill: "url(#paint44_radial_329_4606)"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.6 134.409C1150.04 135.497 1149.17 136.395 1148.1 136.988C1147.02 137.581 1145.8 137.844 1144.57 137.742C1143.35 137.64 1142.19 137.178 1141.23 136.415C1140.27 135.652 1139.56 134.623 1139.19 133.457C1138.82 132.291 1138.8 131.042 1139.15 129.868C1139.49 128.695 1140.17 127.649 1141.12 126.864C1142.06 126.079 1143.21 125.59 1144.43 125.46C1145.65 125.33 1146.88 125.563 1147.97 126.132C1148.69 126.501 1149.33 127.009 1149.85 127.625C1150.38 128.242 1150.77 128.955 1151.02 129.725C1151.26 130.494 1151.35 131.304 1151.28 132.108C1151.21 132.912 1150.98 133.694 1150.6 134.409Z",
    fill: "url(#paint45_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1150.55 128.65C1150.44 129.643 1150.09 130.595 1149.53 131.421C1148.97 132.246 1148.21 132.92 1147.32 133.383C1146.43 133.846 1145.44 134.083 1144.44 134.074C1143.43 134.064 1142.45 133.808 1141.57 133.329C1140.49 132.765 1139.61 131.886 1139.04 130.81C1138.87 132.047 1139.1 133.306 1139.68 134.411C1140.26 135.516 1141.18 136.414 1142.29 136.979C1143.46 137.589 1144.79 137.81 1146.09 137.609C1147.39 137.408 1148.59 136.795 1149.52 135.862C1150.44 134.929 1151.04 133.724 1151.23 132.426C1151.42 131.127 1151.18 129.804 1150.55 128.65Z",
    fill: "url(#paint46_radial_329_4606)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.64 146.028C1180.07 147.09 1179.19 147.959 1178.12 148.527C1177.05 149.095 1175.84 149.335 1174.64 149.219C1173.43 149.102 1172.29 148.633 1171.35 147.87C1170.41 147.108 1169.72 146.086 1169.36 144.934C1169 143.781 1169 142.549 1169.34 141.393C1169.69 140.236 1170.36 139.207 1171.29 138.434C1172.22 137.661 1173.36 137.178 1174.56 137.048C1175.77 136.917 1176.98 137.144 1178.06 137.699C1178.78 138.073 1179.42 138.586 1179.94 139.208C1180.47 139.831 1180.86 140.55 1181.1 141.325C1181.34 142.1 1181.42 142.915 1181.34 143.722C1181.26 144.53 1181.03 145.313 1180.64 146.028Z",
    fill: "url(#paint47_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1180.64 140.217C1180.54 140.968 1180.31 141.697 1179.97 142.376C1179.44 143.353 1178.65 144.169 1177.69 144.737C1176.73 145.305 1175.64 145.606 1174.52 145.606C1173.41 145.606 1172.31 145.305 1171.36 144.737C1170.4 144.169 1169.61 143.353 1169.08 142.376C1168.88 143.809 1169.2 145.265 1169.98 146.485C1170.76 147.706 1171.95 148.612 1173.33 149.043C1174.72 149.474 1176.21 149.403 1177.55 148.841C1178.89 148.28 1179.98 147.264 1180.64 145.975C1181.1 145.085 1181.34 144.098 1181.34 143.096C1181.34 142.094 1181.1 141.107 1180.64 140.217Z",
    fill: "url(#paint48_radial_329_4606)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.84 154.356C1212.27 155.418 1211.39 156.287 1210.33 156.855C1209.26 157.423 1208.04 157.664 1206.84 157.547C1205.63 157.43 1204.49 156.961 1203.55 156.198C1202.61 155.436 1201.92 154.414 1201.57 153.262C1201.21 152.109 1201.2 150.878 1201.55 149.721C1201.89 148.565 1202.57 147.535 1203.5 146.762C1204.43 145.989 1205.57 145.507 1206.77 145.376C1207.97 145.245 1209.19 145.472 1210.26 146.027C1210.99 146.401 1211.63 146.914 1212.15 147.536C1212.67 148.159 1213.06 148.878 1213.3 149.653C1213.54 150.428 1213.63 151.243 1213.55 152.05C1213.47 152.858 1213.23 153.641 1212.84 154.356Z",
    fill: "url(#paint49_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1212.79 148.545C1212.73 149.298 1212.52 150.032 1212.17 150.704C1211.66 151.689 1210.88 152.516 1209.93 153.098C1208.98 153.68 1207.89 153.996 1206.77 154.011C1205.66 154.027 1204.56 153.743 1203.59 153.188C1202.63 152.633 1201.83 151.828 1201.28 150.858C1201.17 151.812 1201.29 152.778 1201.63 153.678C1201.96 154.578 1202.51 155.387 1203.21 156.039C1203.92 156.691 1204.77 157.169 1205.7 157.432C1206.63 157.696 1207.6 157.738 1208.55 157.557C1209.49 157.375 1210.39 156.974 1211.15 156.386C1211.91 155.798 1212.52 155.04 1212.93 154.172C1213.35 153.305 1213.55 152.353 1213.53 151.393C1213.5 150.433 1213.25 149.493 1212.79 148.648V148.545Z",
    fill: "url(#paint50_radial_329_4606)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1147.71 71.3281C1146.37 73.8986 1139.77 73.1788 1133 69.6829C1126.24 66.1871 1121.86 61.2517 1123.2 58.6298C1124.54 56.0079 1131.15 56.779 1137.91 60.2749C1144.67 63.7708 1149.06 68.6033 1147.71 71.3281Z",
    fill: "url(#paint51_radial_329_4606)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.85 59.6071C1071.12 59.2472 1043.41 48.6054 1046.61 55.4943C1049.81 62.3833 1086.45 92.6124 1136.15 114.256C1136.15 114.256 1058.74 65.7763 1071.12 60.4811",
    fill: "url(#paint52_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1177.13 106.03C1178.27 103.477 1178.83 100.7 1178.75 97.9054C1178.67 95.1108 1177.96 92.37 1176.67 89.8869C1169.13 101.557 1133.88 92.92 1110.24 76.109C1095.22 65.4157 1094.04 59.0922 1096.05 55.5449C1093.7 56.9709 1091.78 58.9938 1090.48 61.4057C1090.21 61.9172 1089.98 62.4503 1089.81 62.9994H1089.13C1089.22 63.5925 1089.36 64.1772 1089.55 64.7473C1089.55 64.7473 1094.71 80.8387 1132.95 99.6034C1155.92 110.862 1171.5 112.764 1180.43 110.708C1179.04 109.731 1177.65 108.806 1176.15 107.88C1176.53 107.292 1176.86 106.673 1177.13 106.03Z",
    fill: "url(#paint53_radial_329_4606)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.95 114.872C1191.77 121.851 1201.91 129.82 1211.24 138.675L1211.97 139.549C1219.04 148.443 1175.84 132.454 1143.53 117.031C1143.53 117.031 1173.57 125.36 1178.83 123.972C1184.1 122.584 1180.95 114.872 1180.95 114.872Z",
    fill: "url(#paint54_radial_329_4606)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M556.113 454.896C552.985 456.113 549.567 456.375 546.29 455.648C543.013 454.921 540.025 453.238 537.705 450.812C535.385 448.385 533.837 445.325 533.256 442.019C532.675 438.712 533.088 435.307 534.443 432.235C535.797 429.163 538.032 426.562 540.865 424.762C543.698 422.961 547.001 422.041 550.357 422.119C553.712 422.197 556.969 423.269 559.715 425.199C562.462 427.129 564.574 429.831 565.785 432.962C567.405 437.154 567.297 441.818 565.484 445.93C563.671 450.042 560.301 453.267 556.113 454.896Z",
    fill: "url(#paint55_radial_329_4606)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.31 387.739C1315.02 394.459 1330.98 406.913 1344.71 423.941C1358.44 440.969 1369.49 462.014 1376.83 485.116C1382.98 504.282 1395.05 521.21 1407.94 520.99C1420.79 520.945 1426.41 492.997 1414.44 464.154C1402.07 434.176 1385.06 407.909 1364.99 387.799C1344.92 367.688 1322.45 354.389 1299.68 349.139C1279.34 344.536 1264.4 355.941 1266.26 364.921C1267.99 374.265 1283.02 381.344 1298.31 387.739Z",
    fill: "url(#paint56_radial_329_4606)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(803.732 1238.85) scale(1504.23 1498.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(842.543 1087.81) scale(1159.16 1154.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1121.75 1087.81) scale(987.663 983.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(803.731 1238.85) scale(1504.23 1498.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(849.407 1385.01) scale(1159.11 1154.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.634 122.388) scale(90.9885 90.636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1254.1 172.345) rotate(175.444) scale(91.277 90.9278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(889.507 708.813) scale(18.6312 18.559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.145 310.128) scale(14.3476 14.292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(822.57 161.912) scale(14.3476 14.292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.445 446.211) scale(117.568 117.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(486.649 928.333) scale(16.3088 16.2456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(935.481 347.989) rotate(32.7088) scale(615.008 614.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(825.599 557.077) rotate(32.7088) scale(539.486 538.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F1AD39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(909.907 392.419) rotate(32.6341) scale(570.289 569.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFE135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1009.8 497.139) rotate(77.754) scale(569.62 571.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFE135"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 556.3) rotate(32.6341) scale(388.309 387.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 556.3) rotate(32.6341) scale(388.309 387.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1218.72 548.18) rotate(32.6341) scale(78.3517 78.225)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(840.57 565.836) rotate(32.6341) scale(384.037 383.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.858 447.453) rotate(32.6341) scale(79.4842 79.3557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 556.3) rotate(32.6341) scale(387.486 386.859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(729.587 305.083) rotate(32.6341) scale(60.9517 60.8531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1129.3 811.21) rotate(32.6341) scale(76.9103 76.7859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(833.11 575.403) rotate(32.6341) scale(381.308 380.692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1AD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1116.73 114.454) rotate(27.2417) scale(96.817 96.5994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1116.39 112.54) rotate(27.2417) scale(60.3427 60.2071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1186.98 4.86699) rotate(27.2417) scale(271.852 271.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1151.49 73.2699) rotate(27.2417) scale(187.279 186.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1150.64 75.9085) rotate(27.2417) scale(184.335 183.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1167.94 34.9512) rotate(27.2417) scale(135.306 135.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1037.54 56.7532) rotate(27.2417) scale(26.3483 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1062.97 77.733) rotate(27.2418) scale(26.3483 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1090 95.6478) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.04 111.594) rotate(27.2419) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1147.25 125.413) rotate(27.2417) scale(26.3483 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1177.55 137.013) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1036.49 51.74) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1036.29 52.7965) rotate(27.2416) scale(24.6951 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1061.99 72.5824) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1061.84 73.6632) rotate(27.2417) scale(24.6951 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1089.09 90.3591) rotate(27.2417) scale(26.3483 26.2891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1088.94 91.4397) rotate(27.2417) scale(24.6951 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1117.23 106.238) rotate(27.2417) scale(26.3483 26.2891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1117.03 107.294) rotate(27.2417) scale(24.6951 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1146.46 119.896) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1146.26 120.953) rotate(27.2418) scale(24.695 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1176.83 131.359) rotate(27.2417) scale(26.3483 26.2891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1176.68 132.438) rotate(27.2417) scale(24.6951 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1208.91 139.526) rotate(27.2418) scale(26.3482 26.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1208.76 140.606) rotate(27.2418) scale(24.695 24.6395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#57BFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C95B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009FB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1131.44 55.5878) rotate(27.2417) scale(42.2089 42.114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1067.4 56.5307) rotate(27.2417) scale(153.337 152.992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1160.05 50.1412) rotate(27.2417) scale(113.608 113.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1205.19 126.14) rotate(27.2417) scale(107.925 107.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F191BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0077A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(549.976 439.052) rotate(-12.5962) scale(16.9634 16.9679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_329_4606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440.72 482.903) rotate(-131.96) scale(208.925 144.262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_4606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1124.84,
    height: 1100.81,
    fill: "white",
    transform: "translate(302.842)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP003);
export default __webpack_public_path__ + "static/media/p003.a13f7ff346a616751d86a5cca88834de.svg";
export { ForwardRef as ReactComponent };